import { Typography } from '@atlas-metrics/design-system';
import React from 'react';

import clsxm from '@/lib/clsxm';

import { getButtonVariant } from './getButtonStyle';

export type ButtonLinkType = 'primary' | 'secondary-outline';

export type ButtonLinkProps = {
  variant: ButtonLinkType;
  className?: string;
  textClassName?: string;
} & React.ComponentPropsWithRef<'a'>;

const ExternalButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ href, className, variant, children, textClassName, ...rest }, ref) => {
    return (
      <a
        role='button'
        ref={ref}
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        className={clsxm(
          'flex shrink-0 items-center justify-center rounded-xl border px-4 py-1 text-m  font-semibold',
          'webS:py-2',
          getButtonVariant(variant),
          className
        )}
        {...rest}
      >
        <Typography
          variant='body-m'
          bold
          className={clsxm('shrink-0', textClassName)}
        >
          {children}
        </Typography>
      </a>
    );
  }
);

ExternalButtonLink.displayName = 'ButtonLink';

export default ExternalButtonLink;
